import { configureStore } from '@reduxjs/toolkit';
import { persistReducer, persistStore, createTransform } from 'redux-persist';
import createWebStorage from 'redux-persist/lib/storage/createWebStorage';
import { rootReducer } from './reducer';
import purgeMiddleware from './middleware/purgeMiddleware';
import { REDUX_DEVTOOLS_OPTIONS } from './utils/reduxDevToolsSanitizer';
import {
  bootstrapTabSession,
  installTabCloseLogoutHandlers,
} from './utils/tabCloseLogout';

bootstrapTabSession();
installTabCloseLogoutHandlers();

const createPersistStorage = () => {
  if (typeof window === 'undefined') {
    return {
      getItem: async () => null,
      setItem: async () => undefined,
      removeItem: async () => undefined,
    };
  }
  return createWebStorage('session');
};

const AUTH_PERSIST_KEYS = [
    'name',
    'userId',
    'roleTypeId',
    'roleTypeName',
    'phoneNo',
    'email',
    'cnic',
    'code',
    'roleId',
    'roleName',
    'showAllApplicationsFlag',
    'cscID',
    'csc',
    'cfcLevelId',
    'cfcLevelName',
    'divisionCode',
    'circleCode',
    'companyCode',
    'selectedAdminCompanyCode',
    'hierarchy',
    'lastLoginTime',
    'userStatus',
    'currentDateTime',
    'profilePicture',
    'permissions',
    'token',
    'wmsPrivateToken',
    'cities',
];

const authPersistTransform = createTransform(
    (inboundState) => {
        if (!inboundState) return inboundState;
        const slim = {};
        AUTH_PERSIST_KEYS.forEach((key) => {
            if (inboundState[key] !== undefined) {
                slim[key] = inboundState[key];
            }
        });
        return slim;
    },
    (outboundState) => outboundState,
    { whitelist: ['auth'] },
);

const mdmAuthorizationPersistTransform = createTransform(
    (inboundState) => ({
        data: inboundState?.data || null,
        attempted: Boolean(inboundState?.data?.privatekey),
    }),
    (outboundState) => ({
        data: outboundState?.data || null,
        isLoading: false,
        error: null,
        attempted: Boolean(outboundState?.attempted),
    }),
    { whitelist: ['authorization'] },
);

const persistConfig = {
    key: 'root',
    storage: createPersistStorage(),
    whitelist: ['auth', 'authorization'],
    transforms: [authPersistTransform, mdmAuthorizationPersistTransform],
    throttle: 0,
}

const persistedReducer = persistReducer(persistConfig, rootReducer)

export const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
        }).concat(purgeMiddleware),
    // Slimmed state/actions for the Redux DevTools extension only (see reduxDevToolsSanitizer)
    devTools: REDUX_DEVTOOLS_OPTIONS,
})

export const persistor = persistStore(store)
